import { render, staticRenderFns } from "./ImportantNoticePopup.vue?vue&type=template&id=07b8ded5&scoped=true&"
import script from "./ImportantNoticePopup.vue?vue&type=script&lang=js&"
export * from "./ImportantNoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportantNoticePopup.vue?vue&type=style&index=0&id=07b8ded5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8ded5",
  null
  
)

export default component.exports